import { useState } from "react";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { createCity } from "../../redux/apiCalls/cityApiCalls";

const AddCityForm = () => {
  const dispatch = useDispatch();
  const [cityName, setCityName] = useState("");

  // From Submit Handler
  const formSubmitHandler = (e) => {
    e.preventDefault();
    if (cityName.trim() === "") return toast.error("يجب ادخال المدينة");
    dispatch(createCity({ cityName }));
    setCityName("");
  };

  return (
    <>
      <div className="add-department">
        <h6 className="add-department-title">اضافة مدينة جديدة</h6>
        <form onSubmit={formSubmitHandler} className="add-department-form">
          <div className="add-department-form-group">
            <label htmlFor="title">المدينة</label>
            <input
              value={cityName}
              onChange={(e) => setCityName(e.target.value)}
              type="text"
              id="title"
              placeholder="اضافة مدينة جديدة"
            />
          </div>
          <button type="submit" className="add-department-btn">
            إضافة مدينة
          </button>
        </form>
      </div>
    </>
  );
};
export default AddCityForm;
